jQuery(document).ready(function ($) {
    const tabs = $('.search__tab');

    $.fn.toggleTab = function () {
        const view = this.attr('data-tab-view');

        this.toggleClass('active');
        $(this).closest('.search').find(`.search__view[data-tab-view="${view}"]`).toggleClass('active').toggle();

        return this;
    }

    $.fn.openTab = function () {
        const view = this.attr('data-tab-view');

        this.addClass('active');
        $(this).closest('.search').find(`.search__view[data-tab-view="${view}"]`).addClass('active').show();

        return this;
    }

    $.fn.closeTab = function () {
        this.each(function () {
            const view = $(this).attr('data-tab-view');

            $(this).removeClass('active');
            $(this).closest('.search').find(`.search__view[data-tab-view="${view}"]`).removeClass('active').hide();
        });

        return this;
    }

    tabs.on('click', function (event) {
        event.preventDefault();

        if ($(this).hasClass('active')) {
            return;
        }

        $(this).siblings().closeTab();
        $(this).openTab();
    });
});